<template>
  <div class="hours-compact">

    <div class="hc-toolbar">
      <span class="hc-title">Satnica</span>
      <v-switch
        v-model="onlyFilled"
        dense
        hide-details
        class="ma-0 pa-0 ml-4"
        label="Samo popunjeno"
      ></v-switch>
      <span class="hc-count">{{visibleTypes.length}} / {{hourTypes.length}}</span>
      <v-spacer></v-spacer>
      <span class="hc-total">
        Ukupno: <b>{{ employee.Ukupno }}</b> sati
        <span class="ml-3">Iznos: <b>{{ employee.UkupnoIznos }}</b></span>
      </span>
    </div>

    <div class="hc-grid">
      <div
        v-for="t in visibleTypes"
        :key="t.f"
        class="hc-row"
        :class="{'hc-row--active': isFilled(t)}"
      >
        <div class="hc-name">
          <v-text-field
            v-if="t.descField"
            v-model="employee[t.descField]"
            dense
            hide-details
            single-line
            placeholder="Dodatno"
          ></v-text-field>
          <span v-else :title="t.label">{{t.label}}</span>
        </div>

        <v-text-field
          class="hc-in"
          v-model.number="employee[t.f]"
          dense
          hide-details
          single-line
          type="number"
          placeholder="Sati"
        ></v-text-field>

        <v-text-field
          class="hc-in"
          v-model.number="employee[t.f + 'Posto']"
          dense
          hide-details
          single-line
          type="number"
          placeholder="%"
        ></v-text-field>

        <v-text-field
          class="hc-in hc-in--amount"
          v-model.number="employee[t.f + 'Iznos']"
          dense
          hide-details
          single-line
          type="number"
          disabled
        ></v-text-field>
      </div>
    </div>

    <div class="hc-legend">Naziv &middot; Sati &middot; % &middot; Iznos</div>
  </div>
</template>

<script>
export default {
  name: 'salariehourscompact',
  // The employee object is shared with the parent on purpose: EmployeeEdit3 keeps
  // all watchers on employee.* and recalculates from there, so editing here runs
  // exactly the same calculation as the wide layout - nothing is duplicated.
  props: {
    employee: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      onlyFilled: true,
      // always visible, even when empty - these are the ones used every month
      alwaysShow: ['RedovanRad', 'GodisnjiOdmor', 'BolovanjeDo42Dana'],
      hourTypes: [
        {label: 'Redovan Rad', f: 'RedovanRad'},
        {label: 'Godišnji Odmor', f: 'GodisnjiOdmor'},
        {label: 'Bolovanje Do 42 Dana', f: 'BolovanjeDo42Dana'},
        {label: 'Bolovanje - FOND', f: 'BolovanjeOd42Dana'},
        {label: 'Noćni Rad', f: 'NocniRad'},
        {label: 'Prekovremeni Rad', f: 'PrekovremeniRad'},
        {label: 'Nedjelja', f: 'NedjeljaRad'},
        {label: 'Blagdan', f: 'BlagdanRad'},
        {label: 'Teren', f: 'TerenRad'},
        {label: 'Preraspodjela Rada', f: 'PreraspodjelaRada'},
        {label: 'Pripravnost', f: 'Pripravnost'},
        {label: 'Dnevni Odmor', f: 'DnevniOdmor'},
        {label: 'Tjedni Odmor', f: 'TjedniOdmor'},
        {label: 'Neradni Blagdan', f: 'NeradniBlagdan'},
        {label: 'Rodiljni dop.', f: 'Rodiljni'},
        {label: 'Plaćeni Dopust', f: 'PlaceniDopust'},
        {label: 'Neplaćeni Dopust', f: 'NeplaceniDopust'},
        {label: 'Nenazočnost Na Zahtjev Radnika', f: 'NenazocnostNaZahtjevRadnika'},
        {label: 'Zastoj Krivnjom Poslodavca', f: 'ZastojKrivnjomPoslodavca'},
        {label: 'Štrajk', f: 'Strajk'},
        {label: 'Lockout', f: 'Lockout'},
        {label: 'Vrijeme Mirovanja Radnog Odnosa', f: 'VrijemeMirovanjaRadnogOdnosa'},
        {label: 'Dodatno 1', f: 'Dodatno1', descField: 'Dodatno1Opis'},
        {label: 'Dodatno 2', f: 'Dodatno2', descField: 'Dodatno2Opis'}
      ]
    }
  },
  computed: {
    visibleTypes () {
      if (!this.onlyFilled) { return this.hourTypes }
      return this.hourTypes.filter(t => this.isFilled(t) || this.alwaysShow.indexOf(t.f) !== -1)
    }
  },
  methods: {
    isFilled (t) {
      const hours = parseFloat(this.employee[t.f])
      const amount = parseFloat(this.employee[t.f + 'Iznos'])
      return (hours && hours !== 0) || (amount && amount !== 0)
    }
  }
}
</script>

<style scoped>
.hours-compact {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 6px 8px 8px 8px;
}
.hc-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.hc-title {
  font-weight: 600;
}
.hc-count {
  font-size: 12px;
  color: #757575;
}
.hc-total {
  font-size: 13px;
}
.hc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  column-gap: 18px;
  row-gap: 2px;
}
.hc-row {
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #f0f0f0;
  padding: 1px 0;
}
.hc-row--active {
  background: #f5faff;
}
.hc-name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hc-in {
  flex: 0 0 74px;
  width: 74px;
  margin: 0;
  padding: 0;
  font-size: 13px;
}
.hc-in--amount {
  flex-basis: 92px;
  width: 92px;
}
.hc-legend {
  font-size: 11px;
  color: #9e9e9e;
  margin-top: 6px;
  text-align: right;
}
</style>
